import { connect } from 'react-redux';

import {
    selectIsLoggedIn,
} from 'store/reducers/data/user';

const mapStateToProps = (state) => {
    return {
        isUserLogged: selectIsLoggedIn(state),
    };
};

export default connect(mapStateToProps);
